import "../_scss/app.scss";

import { InViewObserver,inViewObserver } from "./class/InViewObserver.js";
// import { PostIndex } from "./class/PostIndex.js";
import Swiper from 'swiper';

import { smoothScroll } from "./modules/smoothScroll.js";
// import { globalMenuToggle } from "./modules/globalMenuToggle.js";
import { toggleClass } from "./modules/toggleClass.js";
// import { headerScroll } from "./modules/headerScroll.js";
import {aside} from "./modules/aside";
import {tabItem} from "./modules/tabItem";


/**
 * 発火層
 */

document.addEventListener('DOMContentLoaded', function () {
	var btn = document.querySelector('.l-header__btn-menu');
	if (!btn) return;

	btn.addEventListener('click', function () {
		// ボタン自体に active をトグル
		btn.classList.toggle('js-active');

		// 併せてヘッダー/ナビにも active をトグル（必要に応じてCSS側で制御）
		var header = document.querySelector('.l-header');
		if (header) header.classList.toggle('js-active');

		var nav = document.querySelector('.l-header__nav');
		if (nav) nav.classList.toggle('js-active');
	});

	// front-page ヘッダー: kvを超えたら bg-active を付与
	var headerFront = document.querySelector('.l-header.front-page');
	var kv = document.querySelector('.l-topKeyVisual');
	if (headerFront && kv) {
		var updateHeaderBg = function () {
			var headerH = headerFront.offsetHeight || 0;
			var threshold = (kv.offsetTop || 0) + (kv.offsetHeight || 0) - headerH;
			if (window.scrollY > threshold) {
				headerFront.classList.add('bg-active');
			} else {
				headerFront.classList.remove('bg-active');
			}
		};
		updateHeaderBg();
		window.addEventListener('scroll', updateHeaderBg, { passive: true });
		window.addEventListener('resize', updateHeaderBg);
	}

	toggleClass([
		{
			selector: '.c-chat__open',
			className: 'js-active',
			targetSelector: '.c-chat' // 兄弟要素に対して
		},
		{
			selector: '.c-chat__close',
			className: 'js-active',
			targetSelector: '.c-chat' // 兄弟要素に対して
		}
	]);

	smoothScroll({
		offset: () => window.matchMedia('(max-width: 768px)').matches ? 50 : 50,
		duration : 600,
		updateURL: 'replace'
	});
	tabItem();
})

// document.addEventListener('DOMContentLoaded', () => {
// 	// asideBtn();

// 	globalMenuToggle();
// 	toggleClass([
// 		{ selector: '.l-globalNav__link.--toggle'},
// 		{ selector: '.l-footer__navItem.--toggle'}
// 	]);
// 	headerScroll(10);
// 	aside();
//
// 	const postIndex = new PostIndex({
// 		// tocSelector: '#postIndex',
// 		// searchRootSelector: '#postIndexSearch',
// 		activeClass: 'js-postIndex',
// 		titleText: '目次',
// 		showH3: false,
// 		minH2ForDisplay: 2,
// 		// scrollOffset: () => (window.matchMedia('(max-width: 768px)').matches ? 70 : 100)
// 	})
//
//
//
// 	const observer1 = new InViewObserver({offset: 200, removeOnExit: true});
// 	const observer2 = new InViewObserver({ selector:'.m-inView__marker',offset: 200, removeOnExit: true});
// 	// initAsideHiddenOnKeyVisual()
// });


